/* Created By CoolGuy on 2017/12/5
*/
import {observable,action} from 'mobx';
import intl from 'react-intl-universal';
export default class UIStore{
    @observable toast = {
        icon:"",
        iconSize:"",
        show:false,
        content:"",
    };
    @observable alert = {
        show:false,
        title:"",
        content:"",
        buttons:[{
            label:intl.get('ok')||'确定',
            onClick:action(()=>{
                this.alert.show = false;
            }),
        }]
    }
    @observable basicDialog = {
        show:false,
        title:"",
        content:"",
        showCancel:false,
        onCancel:()=>this.hideBasicDialog()
    }
    constructor(rootStore){
        this.rootStore = rootStore;
    }
    @action showToast = ({icon="success-no-circle",iconSize,time,content})=>{
        this.toast = {icon,iconSize,content,show:true}
        console.log("showToast",this.toast);
        if(time){
            setTimeout(action(()=>{
                this.hideToast();
            }),time)
        }
    }
    @action hideToast = ()=>{
        this.toast = {
            ...this.toast,
            show:false,
        }
    }
    @action showAlert = (arg)=>{
        if(typeof arg === 'string'){
            arg = {content:arg};
        }
        this.alert = Object.assign(this.alert,arg,{show:true});
        //console.log(this.alert);
    }
    @action hideAlert = ()=>{
        this.alert = {
            ...this.alert,
            show:false,
        }
    }
    @action showBasicDialog = (arg)=>{
        if(typeof arg === 'string'){
            arg = {content:arg};
        }
        this.basicDialog = Object.assign(this.basicDialog,arg,{show:true});
    }
    @action hideBasicDialog = ()=>{
        this.basicDialog = {
            ...this.basicDialog,
            show:false,
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/UIStore.js